import { MCT_SR_TITLE_ID } from "../config";

export const updateScreenReaderTitle = (title: string) => {
  const srTitleEl = document.getElementById(`${MCT_SR_TITLE_ID}`);
  if (srTitleEl) {
    const children = Array.from(srTitleEl.childNodes);
    for (const child of children) {
      srTitleEl.removeChild(child);
    }
    setTimeout(() => {
      if (!srTitleEl.firstChild) {
        const titleNode = document.createTextNode(title);
        srTitleEl.appendChild(titleNode);
      }
    }, 500);
  }
};
